import axios, {AxiosInstance} from 'axios';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';

export interface BffResponse<T> {
  data: T;
  requestId: string;
}

export default {
  getBaseUrl(useNewGateway?: boolean): string {
    return useNewGateway ? process.env.VUE_APP_NEW_BFF_BASE_URL : process.env.VUE_APP_BFF_BASE_URL;
  },
  getAxiosInstance(): AxiosInstance {
    const instance = axios.create();

    instance.interceptors.request.use(requestInterceptorFulfilledHandler, requestInterceptorRejectedHandler);
    instance.interceptors.response.use(responseInterceptorFulfilledHandler, responseInterceptorRejectedHandler);

    return instance;
  },
};
